import { render, staticRenderFns } from "./chatx-message.vue?vue&type=template&id=aa0ddff2&scoped=true"
import script from "./chatx-message.ts?vue&type=script&lang=ts&external"
export * from "./chatx-message.ts?vue&type=script&lang=ts&external"
import style0 from "./chatx-message.scss?vue&type=style&index=0&id=aa0ddff2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0ddff2",
  null
  
)

export default component.exports